import React from "react";
import { RoleManagement } from "@components/Role";

export default function RoleIndex() {
  return <RoleManagement />;
}
